import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { colors, fontMono } from "../lib/theme";

export default function TopNav() {
  const { session, logout } = useAuth();
  const navigate = useNavigate();

  if (!session) return null;

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <div style={{
      display: "flex", justifyContent: "space-between", alignItems: "center",
      padding: "12px 28px", borderBottom: `1px solid ${colors.line}`, maxWidth: 1100, margin: "0 auto",
    }}>
      <div style={{ display: "flex", gap: 20, alignItems: "center" }}>
        <Link to="/actividades" style={{ display: "flex", alignItems: "center", gap: 8, textDecoration: "none" }}>
          <img src="/brand/icon-flat-white.svg" alt="" width={22} height={22} />
          <span style={{ fontWeight: 700, letterSpacing: "0.06em", color: colors.text }}>CENTINEL DX</span>
        </Link>
        {session.user.isSuperadmin && (
          <Link to="/superadmin" style={navLinkStyle}>Superadmin</Link>
        )}
        <Link to="/organizador" style={navLinkStyle}>Organizador</Link>
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
        <Link
          to="/perfil"
          title="Mi perfil"
          style={{
            fontFamily: fontMono, fontSize: 13, background: colors.panelRaised,
            border: `1px solid ${colors.lineStrong}`, borderRadius: 6, padding: "6px 12px",
            color: colors.text, textDecoration: "none",
          }}
        >
          {session.user.callsign}
        </Link>
        <button onClick={handleLogout} style={{ background: "transparent", border: "none", color: colors.textDim, fontSize: 13, fontWeight: 700, cursor: "pointer" }}>
          Salir
        </button>
      </div>
    </div>
  );
}

const navLinkStyle = { fontSize: 13.5, fontWeight: 600, color: colors.textDim, textDecoration: "none" };
